var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [_c("span", [_vm._v(_vm._s(_vm.ip) + "/" + _vm._s(_vm.mask))])]),
    _vm._v(" "),
    _c("td", { staticClass: "action-column" }, [
      _c("span", [
        _c("a", {
          staticClass: "icon-delete has-tooltip",
          attrs: { title: _vm.t("bruteforcesettings", "Delete") },
          on: {
            click: function($event) {
              return _vm.$emit("delete", _vm.id)
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }